import { useFormik } from 'formik';
import { useEffect } from 'react';
import { PqrFinalCausality } from '../../../../../../shared/types/modules/pqr';
import { useGetNameOrValue } from '../../../../../../shared/utils/useGetNameOrValue';

export const usePqrFinalCausality = (finalCausality?: PqrFinalCausality) => {
    const formik = useFormik({
        initialValues: {
            causality: '',
            motive: '',
            protection: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik.setValues({
            causality: useGetNameOrValue(finalCausality?.causality || ''),
            motive: useGetNameOrValue(finalCausality?.motive || ''),
            protection: useGetNameOrValue(finalCausality?.protection || ''),
        });
    }, [finalCausality]);

    return {
        formik,
    };
};
